const PLATFORM_ALIASES = {
  messager: 'messenger',
}

export function normalizeCustomerPlatform(platform) {
  const value = String(platform || '').trim().toLowerCase()
  return PLATFORM_ALIASES[value] || value
}

export function normalizeCustomerAccount(account) {
  return String(account || '').trim()
}

function isAbsoluteUrl(value) {
  return /^https?:\/\//i.test(String(value || '').trim())
}

function stripPrefix(value, prefix) {
  return String(value || '').replace(prefix, '').trim()
}

function cleanPhone(value) {
  return String(value || '').replace(/[\s+\-()]/g, '')
}

function cleanHandle(value) {
  return stripPrefix(value, /^@+/)
}

export function buildCustomerContactUrl(platform, account) {
  const normalizedPlatform = normalizeCustomerPlatform(platform)
  const rawAccount = normalizeCustomerAccount(account)

  if (!rawAccount) return ''
  if (isAbsoluteUrl(rawAccount)) return rawAccount

  switch (normalizedPlatform) {
    case 'whatsapp':
      return `https://wa.me/${cleanPhone(rawAccount)}?text=hi`
    case 'messenger':
      return `https://m.me/${cleanHandle(rawAccount)}`
    case 'facebook':
      return `https://www.facebook.com/${cleanHandle(rawAccount)}`
    case 'ins':
      return `https://www.instagram.com/${cleanHandle(rawAccount)}/`
    case 'tiktok':
      return `https://www.tiktok.com/@${cleanHandle(rawAccount)}`
    case 'youtube':
      return `https://www.youtube.com/@${cleanHandle(rawAccount)}`
    case 'pinterest':
      return `https://www.pinterest.com/${cleanHandle(rawAccount)}/`
    case 'line':
      return `https://line.me/ti/p/${cleanHandle(rawAccount)}`
    case 'telegram':
      return `https://t.me/${cleanHandle(rawAccount)}`
    default:
      return rawAccount
  }
}

export function getCustomerAccountHint(platform) {
  const normalizedPlatform = normalizeCustomerPlatform(platform)

  const hintMap = {
    whatsapp: {
      title: 'WhatsApp',
      format: 'Use international phone number without +, spaces, or dashes.',
      exampleInput: '85295161824',
      exampleUrl: buildCustomerContactUrl('whatsapp', '85295161824'),
    },
    messenger: {
      title: 'Messenger',
      format: 'Use the page name or username only.',
      exampleInput: 'HKsistershop',
      exampleUrl: buildCustomerContactUrl('messenger', 'HKsistershop'),
    },
    facebook: {
      title: 'Facebook',
      format: 'Use the page name or username only.',
      exampleInput: 'GreenBagStore',
      exampleUrl: buildCustomerContactUrl('facebook', 'GreenBagStore'),
    },
    ins: {
      title: 'Instagram',
      format: 'Use the username only, without @.',
      exampleInput: 'greenbagstore',
      exampleUrl: buildCustomerContactUrl('ins', 'greenbagstore'),
    },
    tiktok: {
      title: 'TikTok',
      format: 'Use the username only, without @.',
      exampleInput: 'greenbagstore',
      exampleUrl: buildCustomerContactUrl('tiktok', 'greenbagstore'),
    },
    youtube: {
      title: 'YouTube',
      format: 'Use the channel handle only, without @.',
      exampleInput: 'greenbagstore',
      exampleUrl: buildCustomerContactUrl('youtube', 'greenbagstore'),
    },
    pinterest: {
      title: 'Pinterest',
      format: 'Use the profile name only.',
      exampleInput: 'greenbagstore',
      exampleUrl: buildCustomerContactUrl('pinterest', 'greenbagstore'),
    },
    line: {
      title: 'Line',
      format: 'Use the profile name only.',
      exampleInput: 'greenbagstore',
      exampleUrl: buildCustomerContactUrl('line', 'greenbagstore'),
    },
    telegram: {
      title: 'Telegram',
      format: 'Use the profile name only.',
      exampleInput: 'greenbagstore',
      exampleUrl: buildCustomerContactUrl('telegram', 'greenbagstore'),
    },
  }

  return hintMap[normalizedPlatform] || {
    title: 'Account',
    format: 'Enter the account identifier only.',
    exampleInput: 'example',
    exampleUrl: '',
  }
}
